import "./marketplace.bfa450ec.js";
import "./MyPortfolio.ff22dad4.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6aa4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6aa4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kVpyw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3bcf4641bf8382d$export$2e2bcd8739ae039);
// Light / dark mode toggle (the .theme-toggle buttons).
// The inline script in each page's <head> already set html[data-theme] before
// the first paint; this only handles the buttons and system changes.
// The visitor's choice is remembered; without one, the system setting wins.
const $f3bcf4641bf8382d$var$KEY = "theme";
function $f3bcf4641bf8382d$export$2e2bcd8739ae039() {
    const root = document.documentElement;
    const system = window.matchMedia("(prefers-color-scheme: dark)");
    const buttons = [
        ...document.querySelectorAll(".theme-toggle")
    ];
    function saved() {
        try {
            const t = localStorage.getItem($f3bcf4641bf8382d$var$KEY);
            return t === "dark" || t === "light" ? t : null;
        } catch  {
            return null;
        }
    }
    function apply(theme) {
        root.dataset.theme = theme;
        const next = theme === "dark" ? "light" : "dark";
        for (const b of buttons){
            b.setAttribute("aria-label", `Switch to ${next} mode`);
            b.title = `Switch to ${next} mode`;
            b.querySelector("i").className = `fa fa-${theme === "dark" ? "sun-o" : "moon-o"}`;
        }
    }
    for (const b of buttons)b.addEventListener("click", ()=>{
        const theme = root.dataset.theme === "dark" ? "light" : "dark";
        try {
            localStorage.setItem($f3bcf4641bf8382d$var$KEY, theme);
        } catch  {}
        apply(theme);
    });
    system.addEventListener("change", (e)=>{
        if (!saved()) apply(e.matches ? "dark" : "light");
    });
    apply(root.dataset.theme === "dark" ? "dark" : "light");
}

});

parcelRegister("wUWAt", function(module, exports) {

$parcel$export(module.exports, "default", () => $062f29282c0d813b$export$2e2bcd8739ae039);
// "Ask about me" chat: a cartoon-character button that opens a chat panel (a card on
// desktop, a full-screen sheet on phones). Questions go to the resume-chat
// service (resume-chat/), which answers from resume.txt with the Ollama model on
// the server and streams the reply back as plain text.
//
// The character reacts to the conversation through classes on .chat:
//   is-open      panel shown        is-thinking  waiting for the first words
//   is-talking   answer streaming   is-sad       something went wrong
// In production Caddy forwards /api/chat to it; locally it runs on localhost:8082.
const $062f29282c0d813b$var$LOCAL = [
    "localhost",
    "127.0.0.1"
].includes(location.hostname);
const $062f29282c0d813b$var$CHAT_URL = ($062f29282c0d813b$var$LOCAL ? "http://localhost:8082" : "") + "/api/chat";
const $062f29282c0d813b$var$WARM_EVERY_MS = 60000; // the server ignores more frequent warm-ups anyway
const $062f29282c0d813b$var$WAKING_AFTER_MS = 6000; // no words yet: the model is probably loading
const $062f29282c0d813b$var$MAX_LEN = 1000; // same limit as the server
const $062f29282c0d813b$var$KEEP = 12; // turns sent with each question
const $062f29282c0d813b$var$TEASER_AFTER_MS = 4000;
const $062f29282c0d813b$var$TEASER_FOR_MS = 7000;
const $062f29282c0d813b$var$TEASER_KEY = "chat-teaser-seen";
const $062f29282c0d813b$var$GREETING = "Hi! I'm Kamado, Abdelilah's assistant. Ask me anything about his skills, projects or experience.";
// One-tap questions under the greeting, for recruiters short on time. The
// server answers the first two from his files at once; the last is a download.
const $062f29282c0d813b$var$QUICK = [
    {
        label: "Abdelilah in 30 seconds",
        ask: "Who is Abdelilah?"
    },
    {
        label: "Is he available?",
        ask: "Is he available?"
    },
    {
        label: "Why hire him?",
        ask: "Why should I hire him?"
    },
    {
        label: "Download his CV",
        href: "/assets/resume.pdf",
        download: "Abdelilah_Bouchikhi_Resume_EN.pdf"
    }
];
const $062f29282c0d813b$var$STATUS = {
    idle: "Online",
    thinking: "Thinking\u2026",
    waking: "Waking up, the first answer takes a moment\u2026",
    talking: "Typing\u2026",
    sad: "Hmm, something went wrong"
};
// Cartoon sidekick (original character): big touching eyes with tiny pupils,
// a bald shiny head, a nervous wavy mouth. Its parts are animated from _chat.scss.
function $062f29282c0d813b$var$robot(extraClass = "") {
    return `
    <svg class="bot ${extraClass}" viewBox="0 0 64 64" aria-hidden="true" focusable="false">
      <g class="bot__head">
        <ellipse class="bot__ear" cx="13.5" cy="36.5" rx="3.6" ry="5" />
        <ellipse class="bot__ear" cx="50.5" cy="36.5" rx="3.6" ry="5" />
        <path class="bot__face" d="M15.5 30C14 18 22 11.5 32 11.5S50.5 18 48.8 31C49.6 44 43 54.5 32 54.5S14.5 44 15.5 30Z" />
        <path class="bot__shine" d="M21.8 19.6q4.3-3.3 10-3.6" />
        <path class="bot__brow" d="M18.6 24.6q5-2.4 10-.2" />
        <path class="bot__brow" d="M35.4 24.4q5-2.2 10 .2" />
        <g class="bot__eye">
          <circle class="bot__white" cx="24.4" cy="34" r="8" />
          <circle class="bot__white" cx="39.6" cy="34" r="8" />
        </g>
        <g class="bot__eyes">
          <circle class="bot__pupil" cx="26" cy="34.4" r="1.6" />
          <circle class="bot__pupil" cx="38" cy="34.4" r="1.6" />
        </g>
        <path class="bot__mouth" d="M25 48.4q1.75-1.9 3.5 0t3.5 0 3.5 0 3.5 0" />
        <path class="bot__drop" d="M52.5 14c1.7 2.6 2.6 4.2 2.6 5.4a2.6 2.6 0 0 1-5.2 0c0-1.2.9-2.8 2.6-5.4Z" />
      </g>
    </svg>`;
}
function $062f29282c0d813b$export$2e2bcd8739ae039() {
    const root = document.createElement("div");
    root.className = "chat";
    root.innerHTML = `
    <p class="chat__teaser" aria-hidden="true">Hi, I'm Kamado! Ask me about Abdelilah</p>
    <button type="button" class="chat__toggle" aria-expanded="false" aria-controls="chat-panel"
      aria-label="Chat with Kamado, Abdelilah's assistant">
      ${$062f29282c0d813b$var$robot("bot--launcher")}
      <span class="chat__toggle-close" aria-hidden="true"><i class="fa fa-times"></i></span>
    </button>
    <section class="chat__panel" id="chat-panel" role="dialog" aria-labelledby="chat-title" inert>
      <header class="chat__head">
        <span class="chat__grip" aria-hidden="true"></span>
        <div class="chat__avatar">${$062f29282c0d813b$var$robot()}</div>
        <div class="chat__title">
          <strong id="chat-title">Kamado</strong>
          <small class="chat__status">${$062f29282c0d813b$var$STATUS.idle}</small>
        </div>
        <button type="button" class="chat__close" aria-label="Close chat"><i class="fa fa-times"></i></button>
      </header>
      <div class="chat__log" aria-live="polite"></div>
      <form class="chat__form">
        <textarea rows="1" maxlength="${$062f29282c0d813b$var$MAX_LEN}" placeholder="Ask a question\u{2026}" aria-label="Your question"
          enterkeyhint="send" required></textarea>
        <button type="submit" aria-label="Send"><i class="fa fa-arrow-up"></i></button>
      </form>
      <p class="chat__note">Kamado is an AI assistant. It can make mistakes.</p>
    </section>`;
    document.body.appendChild(root);
    const toggle = root.querySelector(".chat__toggle");
    const teaser = root.querySelector(".chat__teaser");
    const panel = root.querySelector(".chat__panel");
    const head = root.querySelector(".chat__head");
    const status = root.querySelector(".chat__status");
    const log = root.querySelector(".chat__log");
    const form = root.querySelector(".chat__form");
    const input = form.querySelector("textarea");
    const send = form.querySelector("button");
    // Same breakpoint as the full-screen sheet in _chat.scss
    const phone = window.matchMedia("(max-width: 37.5em), (max-height: 31.25em)");
    const history = [];
    let busy = false;
    let greeted = false;
    // The deck changes slides on wheel and swipe: keep those inside the panel
    for (const type of [
        "wheel",
        "touchstart",
        "touchmove",
        "touchend"
    ])panel.addEventListener(type, (e)=>e.stopPropagation(), {
        passive: true
    });
    // ---- robot mood ----
    function mood(name) {
        root.classList.remove("is-thinking", "is-talking", "is-sad");
        if (name !== "idle") root.classList.add(`is-${name}`);
        status.textContent = $062f29282c0d813b$var$STATUS[name];
    }
    // ---- open / close ----
    function isOpen() {
        return root.classList.contains("is-open");
    }
    function setOpen(open) {
        if (open === isOpen()) return;
        root.classList.toggle("is-open", open);
        panel.inert = !open;
        toggle.setAttribute("aria-expanded", String(open));
        toggle.setAttribute("aria-label", open ? "Close the chat" : "Chat with Kamado, Abdelilah's assistant");
        hideTeaser();
        if (open) {
            warmUp();
            fitViewport();
            if (!greeted) {
                greeted = true;
                setTimeout(()=>{
                    bubble("bot", $062f29282c0d813b$var$GREETING);
                    quickButtons();
                }, 280);
            }
            // On phones the keyboard would cover the greeting: let them tap the field
            if (!phone.matches) setTimeout(()=>input.focus({
                    preventScroll: true
                }), 320);
        } else {
            input.blur();
            if (!phone.matches) toggle.focus({
                preventScroll: true
            });
        }
    }
    toggle.addEventListener("click", ()=>setOpen(!isOpen()));
    // Wake the model up as soon as the visitor shows interest: it loads and reads
    // its notes (up to a minute on the server's CPU) while they type
    let lastWarm = 0;
    function warmUp() {
        if (Date.now() - lastWarm < $062f29282c0d813b$var$WARM_EVERY_MS) return;
        lastWarm = Date.now();
        fetch($062f29282c0d813b$var$CHAT_URL + "/warm", {
            method: "POST",
            keepalive: true
        }).catch(()=>{});
    }
    for (const type of [
        "pointerenter",
        "focus",
        "touchstart"
    ])toggle.addEventListener(type, warmUp, {
        passive: true
    });
    root.querySelector(".chat__close").addEventListener("click", ()=>setOpen(false));
    document.addEventListener("keydown", (e)=>{
        if (e.key === "Escape" && isOpen()) setOpen(false);
    });
    // Phones: drag the header down to close the sheet
    let dragY = null;
    let dragDy = 0;
    head.addEventListener("touchstart", (e)=>{
        if (!phone.matches || e.target.closest("button")) return;
        dragY = e.touches[0].clientY;
        dragDy = 0;
        panel.classList.add("is-dragging");
    }, {
        passive: true
    });
    head.addEventListener("touchmove", (e)=>{
        if (dragY === null) return;
        dragDy = Math.max(0, e.touches[0].clientY - dragY);
        panel.style.setProperty("--drag", `${dragDy}px`);
    }, {
        passive: true
    });
    function endDrag() {
        if (dragY === null) return;
        dragY = null;
        panel.classList.remove("is-dragging");
        panel.style.removeProperty("--drag");
        if (dragDy > 90) setOpen(false);
    }
    head.addEventListener("touchend", endDrag);
    head.addEventListener("touchcancel", endDrag);
    // Phones: keep the sheet inside the visible area when the keyboard opens
    function fitViewport() {
        const vv = window.visualViewport;
        if (!vv) return;
        root.style.setProperty("--chat-vh", `${vv.height}px`);
        root.style.setProperty("--chat-top", `${vv.offsetTop}px`);
        log.scrollTop = log.scrollHeight;
    }
    window.visualViewport?.addEventListener("resize", fitViewport);
    window.visualViewport?.addEventListener("scroll", fitViewport);
    // ---- teaser bubble next to the robot, once per visit ----
    let teaserSeen = false;
    try {
        teaserSeen = sessionStorage.getItem($062f29282c0d813b$var$TEASER_KEY) === "1";
    } catch  {}
    function hideTeaser() {
        teaser.classList.remove("is-shown");
    }
    if (!teaserSeen) setTimeout(()=>{
        if (isOpen()) return;
        teaser.classList.add("is-shown");
        try {
            sessionStorage.setItem($062f29282c0d813b$var$TEASER_KEY, "1");
        } catch  {}
        setTimeout(hideTeaser, $062f29282c0d813b$var$TEASER_FOR_MS);
    }, $062f29282c0d813b$var$TEASER_AFTER_MS);
    // ---- messages ----
    input.addEventListener("keydown", (e)=>{
        if (e.key === "Enter" && !e.shiftKey && !e.isComposing && !phone.matches) {
            e.preventDefault();
            form.requestSubmit();
        }
    });
    input.addEventListener("input", grow);
    form.addEventListener("submit", (e)=>{
        e.preventDefault();
        ask(input.value);
    });
    function grow() {
        input.style.height = "auto";
        input.style.height = Math.min(input.scrollHeight, 120) + "px";
    }
    function bubble(role, text) {
        const row = document.createElement("div");
        row.className = `chat__row chat__row--${role}`;
        if (role === "bot") row.innerHTML = `<span class="chat__mini">${$062f29282c0d813b$var$robot()}</span>`;
        const msg = document.createElement("p");
        msg.className = `chat__msg chat__msg--${role}`;
        msg.textContent = text;
        row.appendChild(msg);
        log.appendChild(row);
        log.scrollTo({
            top: log.scrollHeight,
            behavior: "smooth"
        });
        return msg;
    }
    let quick = null;
    function quickButtons() {
        quick = document.createElement("div");
        quick.className = "chat__quick";
        quick.setAttribute("role", "group");
        quick.setAttribute("aria-label", "Quick questions");
        for (const q of $062f29282c0d813b$var$QUICK){
            const el = document.createElement(q.href ? "a" : "button");
            el.className = "chat__chip";
            el.textContent = q.label;
            if (q.href) {
                el.href = q.href;
                el.download = q.download;
                el.prepend(Object.assign(document.createElement("i"), {
                    className: "fa fa-download"
                }));
            } else {
                el.type = "button";
                el.addEventListener("click", ()=>ask(q.ask));
            }
            quick.appendChild(el);
        }
        log.appendChild(quick);
    }
    function typing() {
        const msg = bubble("bot", "");
        msg.classList.add("chat__msg--typing");
        msg.innerHTML = '<span class="chat__dots" role="img" aria-label="Thinking"><i></i><i></i><i></i></span>';
        return msg;
    }
    async function ask(raw) {
        const question = raw.trim().slice(0, $062f29282c0d813b$var$MAX_LEN);
        if (!question || busy) return;
        busy = true;
        send.disabled = true;
        input.value = "";
        grow();
        // the buttons are a way to start: once the visitor asks, they go
        quick?.remove();
        quick = null;
        bubble("user", question);
        history.push({
            role: "user",
            content: question
        });
        const out = typing();
        mood("thinking");
        const waking = setTimeout(()=>{
            if (out.classList.contains("chat__msg--typing")) status.textContent = $062f29282c0d813b$var$STATUS.waking;
        }, $062f29282c0d813b$var$WAKING_AFTER_MS);
        let answer = "";
        try {
            const res = await fetch($062f29282c0d813b$var$CHAT_URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    messages: history.slice(-$062f29282c0d813b$var$KEEP)
                })
            });
            if (!res.ok) {
                const data = await res.json().catch(()=>({}));
                throw new Error(data.error || "Something went wrong, please try again.");
            }
            const reader = res.body.getReader();
            const decoder = new TextDecoder();
            for(;;){
                const { value: value, done: done } = await reader.read();
                if (done) break;
                answer += decoder.decode(value, {
                    stream: true
                });
                if (!answer) continue;
                if (out.classList.contains("chat__msg--typing")) {
                    out.classList.remove("chat__msg--typing");
                    mood("talking");
                }
                out.textContent = answer;
                log.scrollTop = log.scrollHeight;
            }
            if (!answer.trim()) throw new Error("No answer this time, please try again.");
            history.push({
                role: "assistant",
                content: answer
            });
            mood("idle");
        } catch (err) {
            history.pop(); // forget the unanswered question
            out.classList.remove("chat__msg--typing");
            out.classList.add("chat__msg--error");
            out.textContent = err instanceof TypeError ? "Can't reach Kamado right now." : err.message;
            mood("sad");
            setTimeout(()=>!busy && mood("idle"), 4000);
        } finally{
            clearTimeout(waking);
            busy = false;
            send.disabled = false;
            if (!phone.matches) input.focus({
                preventScroll: true
            });
        }
    }
}

});

parcelRegister("lIWMB", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd0b4e167ebbf7d7$export$2e2bcd8739ae039);
// Job-fit checker (cv.html#fit): a recruiter pastes a job ad and sees which
// of its technologies are in Abdelilah's CV, with where he used them. Plain
// pattern matching in the browser: instant, and the ad never leaves the page.

var $deEn3 = parcelRequire("deEn3");
const $fd0b4e167ebbf7d7$var$found = (list, text)=>list.filter((item)=>item.find.some((re)=>re.test(text)));
// "3+ years", "2-4 years", "5 ans d'expérience": the smallest number asked for
function $fd0b4e167ebbf7d7$var$yearsAsked(text) {
    const m = text.match(/(\d{1,2})\s*(?:\+|-\s*\d{1,2}|à\s*\d{1,2}|to\s*\d{1,2})?\s*(?:years?|yrs|ans|années)/i);
    return m ? Number(m[1]) : 0;
}
function $fd0b4e167ebbf7d7$export$7cbcccfbecde6416(text) {
    return {
        has: $fd0b4e167ebbf7d7$var$found((0, $deEn3.HAS), text),
        close: $fd0b4e167ebbf7d7$var$found((0, $deEn3.CLOSE), text),
        missing: $fd0b4e167ebbf7d7$var$found((0, $deEn3.MISSING), text),
        years: $fd0b4e167ebbf7d7$var$yearsAsked(text)
    };
}
const $fd0b4e167ebbf7d7$var$esc = (s)=>s.replace(/[&<>"]/g, (c)=>({
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;"
        })[c]);
function $fd0b4e167ebbf7d7$var$render(r) {
    const total = r.has.length + r.close.length + r.missing.length;
    if (!total) return `<p class="fit__empty">No technologies recognised in this text. Paste the requirements part of the job ad.</p>`;
    const row = (mark, name, note)=>`<li class="fit__row fit__row--${mark}"><span class="fit__mark" aria-hidden="true"></span><b>${$fd0b4e167ebbf7d7$var$esc(name)}</b><span>${$fd0b4e167ebbf7d7$var$esc(note)}</span></li>`;
    const years = r.years >= 2 ? `<p class="fit__note">The ad asks for ${r.years}+ years. Abdelilah is early in his career: an internship at HPS and freelance work since 2025, plus two years of intensive project-based training.</p>` : "";
    return `
    <p class="fit__score"><b>${r.has.length}</b> of ${total} in his CV${r.close.length ? `, <b>${r.close.length}</b> close` : ""}</p>
    <ul class="fit__list">
      ${r.has.map((s)=>row("has", s.name, s.proof)).join("")}
      ${r.close.map((s)=>row("close", s.name, `close: ${s.near}`)).join("")}
      ${r.missing.map((s)=>row("missing", s.name, "not in his CV")).join("")}
    </ul>
    ${years}
    <p class="fit__cta">Looks like a match? <a href="mailto:bouchikhiabdelilah0@gmail.com?subject=${encodeURIComponent("A role for you")}">Email Abdelilah</a></p>`;
}
function $fd0b4e167ebbf7d7$export$2e2bcd8739ae039(root = document) {
    const form = root.querySelector("#fit-form");
    if (!form) return;
    const input = form.querySelector("textarea");
    const out = root.querySelector("#fit-result");
    const show = ()=>{
        const text = input.value.trim();
        out.innerHTML = text ? $fd0b4e167ebbf7d7$var$render($fd0b4e167ebbf7d7$export$7cbcccfbecde6416(text)) : "";
    };
    form.addEventListener("submit", (e)=>{
        e.preventDefault();
        show();
    });
    form.querySelector("[data-sample]").addEventListener("click", ()=>{
        input.value = (0, $deEn3.SAMPLE);
        show();
    });
}

});
parcelRegister("deEn3", function(module, exports) {

$parcel$export(module.exports, "HAS", () => $9a2be5f5582b3d2e$export$8371b7380a3f8dc2);
$parcel$export(module.exports, "CLOSE", () => $9a2be5f5582b3d2e$export$8a54946d138ed125);
$parcel$export(module.exports, "MISSING", () => $9a2be5f5582b3d2e$export$64c81710c321f252);
$parcel$export(module.exports, "SAMPLE", () => $9a2be5f5582b3d2e$export$f4c761ebe4f59826);
// What the job-fit checker knows. Plain data, kept in step with the CV
// (src/cv.html) and Kamado's files (resume-chat/*.txt): only list what they say.
//
// Each entry: the name shown, the patterns that find it in a job ad (regular
// expressions; case-sensitive ones for short names like Go, C or REST), and
// for skills he has, where he used it.
const $9a2be5f5582b3d2e$var$i = (s)=>new RegExp(s, "i");
const $9a2be5f5582b3d2e$export$8371b7380a3f8dc2 = [
    {
        name: "Java",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bjava\\b(?!\\s*script)"),
            $9a2be5f5582b3d2e$var$i("\\bJ2EE\\b|\\bJakarta EE\\b")
        ],
        proof: "HPS internship (PowerCARD), Marketplace, 01Blog, Lets-Play"
    },
    {
        name: "Spring Boot",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bspring\\b")
        ],
        proof: "HPS internship, Platily, Marketplace, 01Blog, Lets-Play"
    },
    {
        name: "Spring Security",
        find: [
            $9a2be5f5582b3d2e$var$i("spring security")
        ],
        proof: "Lets-Play (JWT, roles), Marketplace (RBAC, mTLS)"
    },
    {
        name: "Spring Cloud / microservices",
        find: [
            $9a2be5f5582b3d2e$var$i("micro-?services?"),
            $9a2be5f5582b3d2e$var$i("spring cloud"),
            $9a2be5f5582b3d2e$var$i("\\beureka\\b"),
            $9a2be5f5582b3d2e$var$i("api gateway")
        ],
        proof: "HPS (microservices monorepo), Marketplace (Gateway, Eureka)"
    },
    {
        name: "JPA / Hibernate",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bjpa\\b"),
            $9a2be5f5582b3d2e$var$i("hibernate")
        ],
        proof: "HPS internship (composite keys, new service)"
    },
    {
        name: "REST APIs",
        find: [
            /\bREST(ful)?\b/,
            $9a2be5f5582b3d2e$var$i("\\brestful\\b"),
            $9a2be5f5582b3d2e$var$i("\\bapi rest\\b")
        ],
        proof: "HPS, Platily (WordPress, Pinterest APIs), Lets-Play"
    },
    {
        name: "gRPC",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bgrpc\\b")
        ],
        proof: "listed in his backend skills"
    },
    {
        name: "SQL",
        find: [
            /\bSQL\b/,
            $9a2be5f5582b3d2e$var$i("relational database|base de donn[\xe9e]es relationnelle")
        ],
        proof: "HPS (SQL schemas, migrations), 01Blog"
    },
    {
        name: "PostgreSQL",
        find: [
            $9a2be5f5582b3d2e$var$i("postgre(s|sql)?\\b")
        ],
        proof: "Platily, 01Blog"
    },
    {
        name: "MySQL",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bmysql\\b")
        ],
        proof: "LeetCode SQL problems, listed skill"
    },
    {
        name: "Liquibase / migrations",
        find: [
            $9a2be5f5582b3d2e$var$i("liquibase"),
            $9a2be5f5582b3d2e$var$i("\\bflyway\\b"),
            $9a2be5f5582b3d2e$var$i("database migrations?")
        ],
        proof: "HPS internship (Liquibase)"
    },
    {
        name: "MongoDB",
        find: [
            $9a2be5f5582b3d2e$var$i("mongo(db)?\\b")
        ],
        proof: "Marketplace, Lets-Play"
    },
    {
        name: "Redis",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bredis\\b")
        ],
        proof: "Marketplace (rate limiting)"
    },
    {
        name: "Kafka",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bkafka\\b")
        ],
        proof: "Marketplace (events between services)"
    },
    {
        name: "OpenSearch",
        find: [
            $9a2be5f5582b3d2e$var$i("opensearch")
        ],
        proof: "HPS internship, Marketplace (search)"
    },
    {
        name: "Angular",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bangular\\b")
        ],
        proof: "Marketplace, 01Blog, Platily"
    },
    {
        name: "TypeScript",
        find: [
            $9a2be5f5582b3d2e$var$i("typescript|\\bTS\\b")
        ],
        proof: "Angular projects (Marketplace, 01Blog)"
    },
    {
        name: "JavaScript",
        find: [
            $9a2be5f5582b3d2e$var$i("javascript|\\bJS\\b|ecmascript|\\bES6\\b")
        ],
        proof: "Bomberman, Tetris, this site"
    },
    {
        name: "RxJS",
        find: [
            $9a2be5f5582b3d2e$var$i("\\brxjs\\b")
        ],
        proof: "Angular projects"
    },
    {
        name: "Next.js / React",
        find: [
            $9a2be5f5582b3d2e$var$i("next\\.?js"),
            $9a2be5f5582b3d2e$var$i("\\breact(\\.?js)?\\b(?!\\s*native)")
        ],
        proof: "listed frontend skill (Next.js)"
    },
    {
        name: "HTML / CSS",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bhtml5?\\b"),
            $9a2be5f5582b3d2e$var$i("\\bcss3?\\b"),
            $9a2be5f5582b3d2e$var$i("\\bsass\\b|\\bscss\\b")
        ],
        proof: "Bomberman, Tetris, this site"
    },
    {
        name: "WebSockets",
        find: [
            $9a2be5f5582b3d2e$var$i("websockets?")
        ],
        proof: "Bomberman (real-time multiplayer)"
    },
    {
        name: "Docker",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bdocker\\b"),
            $9a2be5f5582b3d2e$var$i("containeri[sz]")
        ],
        proof: "HPS, Platily, 01Blog, this site"
    },
    {
        name: "Kubernetes",
        find: [
            $9a2be5f5582b3d2e$var$i("kubernetes|\\bk8s\\b")
        ],
        proof: "HPS internship (deployments, debugging)"
    },
    {
        name: "CI/CD (Jenkins)",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bjenkins\\b"),
            $9a2be5f5582b3d2e$var$i("\\bci ?/ ?cd\\b|continuous (integration|delivery|deployment)")
        ],
        proof: "Marketplace (Jenkins, automatic rollback)"
    },
    {
        name: "AWS",
        find: [
            $9a2be5f5582b3d2e$var$i("\\baws\\b|amazon web services|\\bec2\\b|cloudwatch|\\bs3\\b")
        ],
        proof: "Marketplace (EC2, S3), HPS (CloudWatch)"
    },
    {
        name: "Git",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bgit\\b")
        ],
        proof: "every project, HPS team workflow"
    },
    {
        name: "Linux",
        find: [
            $9a2be5f5582b3d2e$var$i("\\blinux\\b|\\bunix\\b")
        ],
        proof: "Minishell (a Unix shell in C), runs his own server"
    },
    {
        name: "Bash / shell",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bbash\\b|shell script")
        ],
        proof: "ALX, piscine-scripting"
    },
    {
        name: "Gradle",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bgradle\\b")
        ],
        proof: "HPS (multi-module monorepo), Lets-Play"
    },
    {
        name: "Grafana / monitoring",
        find: [
            $9a2be5f5582b3d2e$var$i("grafana|observability|monitoring")
        ],
        proof: "HPS (Grafana, JProfiler, CloudWatch)"
    },
    {
        name: "Testing (JUnit, REST Assured, k6)",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bjunit\\b|rest assured|\\bk6\\b|unit tests?|tests? unitaires|load test")
        ],
        proof: "Lets-Play (JUnit 5), Marketplace (REST Assured, k6)"
    },
    {
        name: "JWT / authentication",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bjwt\\b|oauth2?|authenti(cation|fication)")
        ],
        proof: "Lets-Play, 01Blog, Marketplace, Platily (Firebase Auth)"
    },
    {
        name: "Go",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bgolang\\b"),
            /\bGo\b(?=\s*[,/)]|\s+(?:and|or|et|ou)\b)/,
            /[,(/]\s*Go\b/
        ],
        proof: "Kamado (this site's assistant), 01 exercises on his GitHub"
    },
    {
        name: "Rust",
        find: [
            /\bRust\b/
        ],
        proof: "among the languages he has worked with"
    },
    {
        name: "C",
        find: [
            /(?<![\w'’])C(?=\s*[,/)]|\s+(?:and|or|et|ou)\b|\s+programming)/,
            /[,(/]\s*C\b(?![+#'’])/,
            /\b(?:and|or|et|ou)\s+C\b(?![+#'’])/
        ],
        proof: "1337 (Minishell, so_long, push_swap)"
    },
    {
        name: "Python",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bpython\\b")
        ],
        proof: "ALX program (AirBnB clone)"
    },
    {
        name: "Team work",
        find: [
            $9a2be5f5582b3d2e$var$i("team ?work|travail en [\xe9e]quipe|teamwork|collaborat")
        ],
        proof: "Bomberman (4), Tetris (3), Minishell (2), HPS team"
    },
    {
        name: "English",
        find: [
            $9a2be5f5582b3d2e$var$i("\\benglish\\b|\\banglais\\b")
        ],
        proof: "fluent"
    },
    {
        name: "French",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bfrench\\b|\\bfran[\xe7c]ais\\b")
        ],
        proof: "intermediate"
    },
    {
        name: "Arabic",
        find: [
            $9a2be5f5582b3d2e$var$i("\\barabic\\b|\\barabe\\b")
        ],
        proof: "native"
    },
    {
        name: "Maven",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bmaven\\b")
        ],
        proof: "Marketplace (payments service)"
    },
    {
        name: "Node.js",
        find: [
            $9a2be5f5582b3d2e$var$i("node\\.?js")
        ],
        proof: "Bomberman (WebSocket game server)"
    },
    {
        name: "GraphQL",
        find: [
            $9a2be5f5582b3d2e$var$i("graphql")
        ],
        proof: "graphQl project (JavaScript client of a GraphQL API)"
    },
    {
        name: "Prometheus",
        find: [
            $9a2be5f5582b3d2e$var$i("prometheus")
        ],
        proof: "Marketplace (metrics from the gateway and services, Grafana dashboards)"
    },
    {
        name: "Caddy / Nginx",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bcaddy\\b|\\bnginx\\b|reverse proxy")
        ],
        proof: "Marketplace and this site (Caddy reverse proxy, HTTPS)"
    },
    {
        name: "Stripe / payments",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bstripe\\b|payment")
        ],
        proof: "Marketplace (Stripe Checkout, webhooks, stock reservation)"
    }
];
const $9a2be5f5582b3d2e$export$8a54946d138ed125 = [
    {
        name: "Elasticsearch",
        find: [
            $9a2be5f5582b3d2e$var$i("elastic ?search|\\bELK\\b")
        ],
        near: "OpenSearch is a fork of Elasticsearch"
    },
    {
        name: "RabbitMQ / messaging",
        find: [
            $9a2be5f5582b3d2e$var$i("rabbitmq|activemq|\\bjms\\b|message (broker|queue)")
        ],
        near: "Kafka"
    },
    {
        name: "Azure",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bazure\\b")
        ],
        near: "AWS"
    },
    {
        name: "Google Cloud",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bgcp\\b|google cloud")
        ],
        near: "AWS"
    },
    {
        name: "GitLab CI / GitHub Actions",
        find: [
            $9a2be5f5582b3d2e$var$i("gitlab|github actions")
        ],
        near: "Jenkins CI/CD"
    },
    {
        name: "Oracle / SQL Server",
        find: [
            $9a2be5f5582b3d2e$var$i("\\boracle\\b|sql server|\\bmssql\\b|mariadb")
        ],
        near: "SQL, PostgreSQL, MySQL"
    },
    {
        name: "Vue / Svelte",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bvue(\\.?js)?\\b|\\bsvelte\\b")
        ],
        near: "Angular, Next.js"
    },
    {
        name: "Quarkus / Micronaut",
        find: [
            $9a2be5f5582b3d2e$var$i("quarkus|micronaut")
        ],
        near: "Spring Boot"
    },
    {
        name: "Kibana / Logstash",
        find: [
            $9a2be5f5582b3d2e$var$i("kibana|logstash")
        ],
        near: "OpenSearch, Fluent Bit, Grafana"
    },
    {
        name: "Express / NestJS",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bexpress(\\.js)?\\b|\\bnestjs\\b")
        ],
        near: "Node.js (Bomberman's server)"
    },
    {
        name: "Terraform / Ansible",
        find: [
            $9a2be5f5582b3d2e$var$i("terraform|ansible|infrastructure as code")
        ],
        near: "Docker, Kubernetes, AWS"
    },
    {
        name: "Agile / Scrum",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bagile\\b|\\bscrum\\b|\\bkanban\\b")
        ],
        near: "team projects at Zone01 and the HPS team"
    }
];
const $9a2be5f5582b3d2e$export$64c81710c321f252 = [
    {
        name: "C# / .NET",
        find: [
            /C#/,
            $9a2be5f5582b3d2e$var$i("\\.net\\b|asp\\.net|dotnet")
        ]
    },
    {
        name: "PHP / Laravel / Symfony",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bphp\\b|laravel|symfony")
        ]
    },
    {
        name: "Ruby / Rails",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bruby\\b|\\brails\\b")
        ]
    },
    {
        name: "Kotlin",
        find: [
            $9a2be5f5582b3d2e$var$i("kotlin")
        ]
    },
    {
        name: "Scala",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bscala\\b")
        ]
    },
    {
        name: "C++",
        find: [
            /C\+\+/
        ]
    },
    {
        name: "Swift / iOS",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bswift\\b|\\bios\\b")
        ]
    },
    {
        name: "Android",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bandroid\\b")
        ]
    },
    {
        name: "Flutter / React Native",
        find: [
            $9a2be5f5582b3d2e$var$i("flutter|react native|\\bdart\\b")
        ]
    },
    {
        name: "Django / Flask / FastAPI",
        find: [
            $9a2be5f5582b3d2e$var$i("django|flask|fastapi")
        ]
    },
    {
        name: "Spark / Hadoop",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bspark\\b|hadoop")
        ]
    },
    {
        name: "Cassandra",
        find: [
            $9a2be5f5582b3d2e$var$i("cassandra")
        ]
    },
    {
        name: "SAP",
        find: [
            $9a2be5f5582b3d2e$var$i("\\bsap\\b")
        ]
    },
    {
        name: "Salesforce",
        find: [
            $9a2be5f5582b3d2e$var$i("salesforce")
        ]
    },
    {
        name: "Machine learning",
        find: [
            $9a2be5f5582b3d2e$var$i("machine learning|\\bml\\b|deep learning|tensorflow|pytorch")
        ]
    }
];
const $9a2be5f5582b3d2e$export$f4c761ebe4f59826 = `Java Developer (Spring Boot) \u{2013} Casablanca / hybrid

We're looking for a backend developer to join our payments team.
- Java 17, Spring Boot, Spring Security, REST APIs, microservices
- PostgreSQL, Redis, Kafka or RabbitMQ
- Docker, Kubernetes, GitLab CI
- Angular is a plus
- 2+ years of experience, English and French`;

});



var $kVpyw = parcelRequire("kVpyw");
// Code background: faint blocks of code (his stack: Spring Boot, Kafka,
// Angular, SQL, Docker...) type themselves out across the page.
// - Each block types a snippet with a blinking cursor, holds it, fades out and
//   starts another one, so the page always looks like work in progress.
// - Monochrome syntax shading: keywords and annotations darker, comments and
//   strings lighter. Code near the cursor darkens a little, like a flashlight.
// - Parallax between slides and the dark/light swap stay in CSS
//   (transform/filter on the canvas), so they never cost a redraw.
// - Some spots run a tiny C program instead: a while (i < 10) loop whose
//   current line lights up, and on each turn an address drops from the call
//   into the parameter of the function below.
// - The middle of the screen stays clear, so the slide's text is always readable.
// - With reduced motion the snippets are drawn once, fully typed, and stay still.
const $9cc7f751f8d72599$var$FONT_SIZE = 12;
const $9cc7f751f8d72599$var$LINE_HEIGHT = 18;
const $9cc7f751f8d72599$var$BLOCK_WIDTH = 470; // px of canvas per block column
const $9cc7f751f8d72599$var$TYPE_CPS = [
    18,
    34
]; // typing speed range, characters per second
const $9cc7f751f8d72599$var$HOLD_MS = [
    4000,
    9000
]; // how long a finished snippet stays
const $9cc7f751f8d72599$var$FADE_MS = 1200;
const $9cc7f751f8d72599$var$LIGHT_RADIUS = 220;
// The middle of the screen holds the slide's text: code fades out there
const $9cc7f751f8d72599$var$CLEAR_X = 0.41; // half-width of the clear area, fraction of the viewport width
const $9cc7f751f8d72599$var$CLEAR_Y = 0.43; // half-height, fraction of the viewport height
const $9cc7f751f8d72599$var$FRAME_MS = 1000 / 30;
const $9cc7f751f8d72599$var$LIGHT_BOOST = 2.0; // contrast on light pages (see updateBoost)
const $9cc7f751f8d72599$var$INK = "10,10,10";
// Must match the parallax step used in _base.scss
const $9cc7f751f8d72599$var$PARALLAX_PER_SLIDE = 140;
const $9cc7f751f8d72599$var$SNIPPETS = [
    `@RestController
@RequestMapping("/api/products")
public class ProductController {

  private final ProductService products;

  @GetMapping("/{id}")
  public ProductDto get(@PathVariable String id) {
    return products.findById(id)
        .orElseThrow(NotFoundException::new);
  }
}`,
    `@KafkaListener(topics = "remove-product-events")
public void onProductRemoved(ProductEvent event) {
  // clean up the images nobody uses anymore
  media.deleteByProduct(event.productId());
  log.info("media cleaned for {}", event.productId());
}`,
    `@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
})
export class ProductCardComponent {
  @Input() product!: Product;
  @Output() addToCart = new EventEmitter<Product>();

  buy(): void {
    this.addToCart.emit(this.product);
  }
}`,
    `-- liquibase formatted sql
-- changeset abdelilah:7
CREATE TABLE product_rating (
  product_id  VARCHAR(36) NOT NULL,
  user_id     VARCHAR(36) NOT NULL,
  stars       SMALLINT    NOT NULL,
  PRIMARY KEY (product_id, user_id)
);`,
    `FROM eclipse-temurin:17-jre-alpine
WORKDIR /app
COPY build/libs/service.jar app.jar
USER 10001
EXPOSE 8080
ENTRYPOINT ["java", "-jar", "app.jar"]`,
    `public class Abdelilah implements FullStackDeveloper {

  @Override
  public List<String> stack() {
    return List.of("Java", "Spring Boot",
        "Angular", "Next.js", "PostgreSQL");
  }

  @Override
  public boolean availableForHire() {
    return true; // from November 2026
  }
}`,
    `GET /products/_search
{
  "query": {
    "multi_match": {
      "query": "wireless keyboard",
      "fields": ["name^3", "description"]
    }
  }
}`,
    `@Bean
SecurityFilterChain api(HttpSecurity http) throws Exception {
  return http
      .csrf(csrf -> csrf.disable())
      .authorizeHttpRequests(auth -> auth
          .requestMatchers("/api/auth/**").permitAll()
          .anyRequest().authenticated())
      .oauth2ResourceServer(o -> o.jwt(withDefaults()))
      .build();
}`,
    `$ ./mvnw test
[INFO] Running ProductServiceTest
[INFO] Running CheckoutSessionTest
[INFO] Running MediaCleanupListenerTest
[INFO] Tests run: 48, Failures: 0
[INFO] BUILD SUCCESS`,
    `func (s *Server) getPost(w http.ResponseWriter, r *http.Request) {
	post, err := s.store.Get(r.Context(), r.PathValue("slug"))
	if errors.Is(err, ErrNotFound) {
		http.Error(w, "not found", http.StatusNotFound)
		return
	}
	writeJSON(w, http.StatusOK, post)
}`,
    `fn parse_line(line: &str) -> Option<(String, u32)> {
    let mut parts = line.split_whitespace();
    let name = parts.next()?.to_string();
    let score = parts.next()?.parse().ok()?;
    Some((name, score))
}`,
    `char *ft_strdup(const char *s)
{
    size_t  len;
    char    *copy;

    len = ft_strlen(s) + 1;
    copy = malloc(len);
    if (!copy)
        return (NULL);
    return (ft_memcpy(copy, s, len));
}`,
    `#!/usr/bin/env bash
set -euo pipefail

git pull --ff-only
npm run build
docker compose up -d --build
curl -fs https://abdelilah.bouchikhi.com > /dev/null \\
  && echo "deployed"`,
    `const res = await fetch("/api/posts?page=1");
const { posts } = await res.json();

list.innerHTML = posts
  .map((p) => "<li>" + escape(p.title) + "</li>")
  .join("");`,
    `export default function PostCard({ post }) {
  return (
    <article className="card">
      <h2>{post.title}</h2>
      <p>{post.summary}</p>
    </article>
  );
}`,
    `apiVersion: apps/v1
kind: Deployment
metadata:
  name: products-service
spec:
  replicas: 2
  template:
    spec:
      containers:
        - name: products
          image: registry/products:1.4.0
          ports:
            - containerPort: 8000`,
    `pipeline {
  agent any
  stages {
    stage('Test')   { steps { sh './mvnw test' } }
    stage('Build')  { steps { sh 'docker compose build' } }
    stage('Deploy') { steps { sh './scripts/deploy.sh' } }
  }
  post {
    failure { sh './scripts/rollback.sh' }
  }
}`,
    `.route("products", r -> r.path("/api/products/**")
    .filters(f -> f.requestRateLimiter(c -> c
        .setRateLimiter(redisRateLimiter())
        .setKeyResolver(ipKeyResolver)))
    .uri("lb://products"))`
];
// Editor-style tab above each snippet (same order as SNIPPETS), so the stack
// reads at a glance
const $9cc7f751f8d72599$var$SNIPPET_FILES = [
    "ProductController.java \xb7 Spring Boot",
    "MediaListener.java \xb7 Kafka",
    "product-card.component.ts \xb7 Angular",
    "007-product-rating.sql \xb7 Liquibase",
    "Dockerfile \xb7 Docker",
    "Abdelilah.java \xb7 Java",
    "search.http \xb7 OpenSearch",
    "SecurityConfig.java \xb7 Spring Security",
    "terminal \xb7 Maven",
    "server.go \xb7 Go",
    "parser.rs \xb7 Rust",
    "ft_strdup.c \xb7 C",
    "deploy.sh \xb7 Bash",
    "posts.js \xb7 JavaScript",
    "PostCard.jsx \xb7 Next.js",
    "deployment.yaml \xb7 Kubernetes",
    "Jenkinsfile \xb7 CI/CD",
    "GatewayConfig.java \xb7 Redis"
];
const $9cc7f751f8d72599$var$PROGRAM_FILE = "loop.c \xb7 C";
// The running program: main() calls process() ten times, then starts over
const $9cc7f751f8d72599$var$PROGRAM_MAIN = [
    "int main(void) {",
    "  int data[10];",
    "  int i = 0;",
    "  while (i < 10) {",
    "    process(&data[i]);",
    "    i++;",
    "  }",
    "}"
];
const $9cc7f751f8d72599$var$PROGRAM_FN = [
    "void process(int *p) {",
    "  *p = *p * 2;",
    "}"
];
const $9cc7f751f8d72599$var$LINE_I = 2; // "int i = 0;"
const $9cc7f751f8d72599$var$LINE_WHILE = 3;
const $9cc7f751f8d72599$var$LINE_CALL = 4;
const $9cc7f751f8d72599$var$LINE_INC = 5;
const $9cc7f751f8d72599$var$STEP_MS = 1100; // one loop turn
const $9cc7f751f8d72599$var$PAUSE_MS = 2600; // after i reaches 10
const $9cc7f751f8d72599$var$BASE_ADDR = 0x7ffe4a20;
const $9cc7f751f8d72599$var$KEYWORDS = new Set(`public private protected class interface implements extends return new final static void boolean
  if else for while throws throw import export from const let this true false null select from where
  create table primary key not insert into values get post put delete from workdir copy user expose
  entrypoint run int void char fn let mut func nil package defer impl pub struct match async await
  default function set echo pipeline stage steps agent apiversion kind spec metadata`.split(/\s+/));
// Splits a line into [text, weight] tokens: 0 plain, 1 strong (keywords,
// annotations), -1 faint (comments, strings).
function $9cc7f751f8d72599$var$tokenize(line) {
    const trimmed = line.trimStart();
    if (trimmed.startsWith("//") || trimmed.startsWith("--") || trimmed.startsWith("#")) return [
        [
            line,
            -1
        ]
    ];
    const out = [];
    const re = /("[^"]*"?|'[^']*'?|@\w+|\/\/.*$|\b\w+\b|\s+|[^\w\s"'@]+)/g;
    let m;
    while(m = re.exec(line)){
        const t = m[0];
        let w = 0;
        if (t.startsWith('"') || t.startsWith("'") || t.startsWith("//")) w = -1;
        else if (t.startsWith("@") || $9cc7f751f8d72599$var$KEYWORDS.has(t.toLowerCase()) || /^[A-Z][A-Z_]+$/.test(t)) w = 1;
        out.push([
            t,
            w
        ]);
    }
    return out;
}
const $9cc7f751f8d72599$var$rand = (a, b)=>a + Math.random() * (b - a);
function $9cc7f751f8d72599$export$2e2bcd8739ae039() {
    const canvas = document.getElementById("backdrop");
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let width = 0;
    let height = 0;
    let dpr = 1;
    let slideCount = 1;
    let running = false;
    let lastFrame = 0;
    let blocks = [];
    let programs = []; // the running while loops
    let deck = []; // shuffled snippet indexes, so neighbours differ
    const pointer = {
        x: -9999,
        y: -9999,
        active: false
    };
    // Grey code on white reads much weaker than the same code inverted on black:
    // on light pages it gets more contrast
    let boost = 1;
    function updateBoost() {
        boost = document.documentElement.dataset.theme === "dark" ? 1 : $9cc7f751f8d72599$var$LIGHT_BOOST;
    }
    const ink = (alpha)=>`rgba(${$9cc7f751f8d72599$var$INK},${Math.min(1, alpha * boost)})`;
    function nextSnippet() {
        if (!deck.length) deck = $9cc7f751f8d72599$var$SNIPPETS.map((_, i)=>i).sort(()=>Math.random() - 0.5);
        const i = deck.pop();
        return {
            file: $9cc7f751f8d72599$var$SNIPPET_FILES[i] || "",
            lines: $9cc7f751f8d72599$var$SNIPPETS[i].split("\n")
        };
    }
    // The file tab: name · technology, slightly stronger than the code, underlined
    function fileTab(name, x, y, cx, fade = 1) {
        const e = edgeFactor(x + 100, y, cx);
        if (!name || e <= 0) return;
        const ty = y - $9cc7f751f8d72599$var$LINE_HEIGHT - 8;
        const w = ctx.measureText(name).width;
        ctx.fillStyle = ink(0.3 * fade * e);
        ctx.fillText(name, x, ty);
        ctx.fillRect(x, ty + $9cc7f751f8d72599$var$FONT_SIZE + 5, w, 1);
    }
    // A block types one snippet, then holds, fades and restarts with another
    function restart(b, now, delay = 0) {
        const next = nextSnippet();
        b.lines = next.lines;
        b.file = next.file;
        b.total = b.lines.reduce((n, l)=>n + l.length + 1, 0);
        b.cps = $9cc7f751f8d72599$var$rand(...$9cc7f751f8d72599$var$TYPE_CPS);
        b.start = now + delay;
        b.hold = $9cc7f751f8d72599$var$rand(...$9cc7f751f8d72599$var$HOLD_MS);
        b.typed = reduceMotion ? b.total : 0;
    }
    function layout(now) {
        const cols = Math.max(1, Math.round(width / $9cc7f751f8d72599$var$BLOCK_WIDTH));
        const colW = width / cols;
        const rows = height > 760 ? 2 : 1;
        const rowH = height / rows;
        blocks = [];
        programs = [];
        for(let c = 0; c < cols; c++)for(let r = 0; r < rows; r++){
            const b = {
                x: Math.round(c * colW + $9cc7f751f8d72599$var$rand(16, Math.max(24, colW - 360))),
                y: Math.round(r * rowH + $9cc7f751f8d72599$var$rand(84, Math.max(92, rowH - 260)))
            };
            if ((c * rows + r) % 4 === 1 && programs.length < 2) {
                programs.push({
                    x: b.x,
                    y: b.y,
                    start: now + $9cc7f751f8d72599$var$rand(0, 3000)
                });
                continue;
            }
            restart(b, now, reduceMotion ? 0 : $9cc7f751f8d72599$var$rand(0, 6000));
            blocks.push(b);
        }
    }
    // 0 in the middle of the visible screen, 1 towards its edges
    function edgeFactor(x, y, cx) {
        // phones: the text spans almost the whole width
        const clearX = window.innerWidth < 700 ? 0.62 : $9cc7f751f8d72599$var$CLEAR_X;
        const dx = (x - cx) / (window.innerWidth * clearX);
        const dy = (y - height / 2) / (height * $9cc7f751f8d72599$var$CLEAR_Y);
        const d = Math.hypot(dx, dy);
        return Math.min(1, Math.max(0, (d - 0.75) / 0.5));
    }
    function draw(now) {
        updateBoost();
        ctx.clearRect(0, 0, width, height);
        // centre of what is on screen, in canvas coordinates (the canvas slides)
        const cx = -parallaxOffset() + window.innerWidth / 2;
        ctx.font = `${$9cc7f751f8d72599$var$FONT_SIZE}px "JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, monospace`;
        ctx.textBaseline = "top";
        const cursorOn = Math.floor(now / 530) % 2 === 0;
        for (const pg of programs)drawProgram(pg, now, cx);
        for (const b of blocks){
            if (now < b.start) continue;
            const elapsed = now - b.start;
            if (!reduceMotion) b.typed = Math.min(b.total, Math.floor(elapsed / 1000 * b.cps));
            const doneAt = b.total / b.cps * 1000;
            let fade = 1;
            if (!reduceMotion && elapsed > doneAt + b.hold) {
                fade = 1 - (elapsed - doneAt - b.hold) / $9cc7f751f8d72599$var$FADE_MS;
                if (fade <= 0) {
                    restart(b, now, $9cc7f751f8d72599$var$rand(400, 2500));
                    continue;
                }
            }
            fileTab(b.file, b.x, b.y, cx, fade);
            let left = b.typed;
            let cursor = null;
            for(let i = 0; i < b.lines.length && left >= 0; i++){
                const y = b.y + i * $9cc7f751f8d72599$var$LINE_HEIGHT;
                const shown = b.lines[i].slice(0, left);
                left -= b.lines[i].length + 1;
                // the flashlight: code near the pointer is a bit darker
                let light = 0;
                if (pointer.active) {
                    const d = Math.hypot(pointer.x - (b.x + 120), pointer.y - y);
                    light = Math.max(0, 1 - d / $9cc7f751f8d72599$var$LIGHT_RADIUS);
                }
                let x = b.x;
                for (const [text, w] of $9cc7f751f8d72599$var$tokenize(shown)){
                    const tw = ctx.measureText(text).width;
                    const edge = edgeFactor(x + tw / 2, y, cx);
                    if (edge > 0 && text.trim()) {
                        const alpha = (w > 0 ? 0.2 : w < 0 ? 0.09 : 0.13) + light * 0.14;
                        ctx.fillStyle = ink(alpha * fade * edge);
                        ctx.fillText(text, x, y);
                    }
                    x += tw;
                }
                if (left < 0 || i === b.lines.length - 1) cursor = {
                    x: x,
                    y: y
                };
            }
            if (cursor && cursorOn && !reduceMotion) {
                ctx.fillStyle = ink(0.28 * fade * edgeFactor(cursor.x, cursor.y, cx));
                ctx.fillRect(cursor.x + 1, cursor.y, 7, $9cc7f751f8d72599$var$FONT_SIZE + 2);
            }
        }
    }
    // One line of code, shaded like the snippets; strong = the line running now
    function codeLine(text, x, y, cx, strong, fade = 1) {
        let tx = x;
        for (const [t, w] of $9cc7f751f8d72599$var$tokenize(text)){
            const tw = ctx.measureText(t).width;
            const edge = edgeFactor(tx + tw / 2, y, cx);
            if (edge > 0 && t.trim()) {
                const alpha = (w > 0 ? 0.2 : w < 0 ? 0.09 : 0.13) + (strong ? 0.16 : 0);
                ctx.fillStyle = ink(alpha * fade * edge);
                ctx.fillText(t, tx, y);
            }
            tx += tw;
        }
        return tx;
    }
    const hex = (n)=>"0x" + n.toString(16);
    function drawProgram(pg, now, cx) {
        const elapsed = Math.max(0, now - pg.start) % (10 * $9cc7f751f8d72599$var$STEP_MS + $9cc7f751f8d72599$var$PAUSE_MS);
        const done = elapsed >= 10 * $9cc7f751f8d72599$var$STEP_MS;
        const i = done ? 10 : Math.floor(elapsed / $9cc7f751f8d72599$var$STEP_MS);
        const phase = done ? 0 : elapsed % $9cc7f751f8d72599$var$STEP_MS / $9cc7f751f8d72599$var$STEP_MS;
        const active = done ? -1 : phase < 0.25 ? $9cc7f751f8d72599$var$LINE_WHILE : phase < 0.75 ? $9cc7f751f8d72599$var$LINE_CALL : $9cc7f751f8d72599$var$LINE_INC;
        const fnX = pg.x + 36;
        const fnY = pg.y + $9cc7f751f8d72599$var$PROGRAM_MAIN.length * $9cc7f751f8d72599$var$LINE_HEIGHT + 30;
        fileTab($9cc7f751f8d72599$var$PROGRAM_FILE, pg.x, pg.y, cx);
        let callEnd = 0;
        $9cc7f751f8d72599$var$PROGRAM_MAIN.forEach((line, n)=>{
            const y = pg.y + n * $9cc7f751f8d72599$var$LINE_HEIGHT;
            if (n === active) {
                const e = edgeFactor(pg.x + 120, y, cx);
                ctx.fillStyle = ink(0.05 * e);
                ctx.fillRect(pg.x - 6, y - 3, 300, $9cc7f751f8d72599$var$LINE_HEIGHT);
            }
            const end = codeLine(line, pg.x, y, cx, n === active);
            if (n === $9cc7f751f8d72599$var$LINE_I) codeLine(`   // i = ${i}`, end, y, cx, false);
            if (n === $9cc7f751f8d72599$var$LINE_CALL) callEnd = end;
        });
        // process(): its parameter shows the last address it received
        const arrived = !done && phase > 0.85;
        const last = done ? 9 : arrived ? i : i - 1;
        $9cc7f751f8d72599$var$PROGRAM_FN.forEach((line, n)=>{
            const y = fnY + n * $9cc7f751f8d72599$var$LINE_HEIGHT;
            const end = codeLine(line, fnX, y, cx, arrived && n < 2);
            if (n === 0 && last >= 0) codeLine(`   // p = ${hex($9cc7f751f8d72599$var$BASE_ADDR + last * 4)}`, end, y, cx, false);
        });
        // The address of data[i] drops from the call into process(int *p)
        if (!done && phase > 0.3 && phase < 0.9) {
            const q = (phase - 0.3) / 0.6;
            const x0 = callEnd + 10;
            const y0 = pg.y + $9cc7f751f8d72599$var$LINE_CALL * $9cc7f751f8d72599$var$LINE_HEIGHT;
            const x1 = fnX + ctx.measureText("void process(int ").width;
            const y1 = fnY + 2;
            const x = x0 + (x1 - x0) * q;
            const y = y0 + (y1 - y0) * q * q; // falls faster and faster
            const fade = Math.min(1, q * 5, (1 - q) * 6);
            const e = edgeFactor(x, y, cx);
            ctx.fillStyle = ink(0.42 * fade * e);
            ctx.fillText(hex($9cc7f751f8d72599$var$BASE_ADDR + i * 4), x, y);
        }
    }
    function frame(time) {
        if (!running) return;
        requestAnimationFrame(frame);
        if (time - lastFrame < $9cc7f751f8d72599$var$FRAME_MS) return;
        lastFrame = time;
        draw(time);
    }
    function start() {
        if (running || reduceMotion || document.hidden) return;
        running = true;
        requestAnimationFrame(frame);
    }
    function resize() {
        dpr = Math.min(window.devicePixelRatio || 1, 2);
        // Wider than the viewport so it can slide sideways with the slides
        width = window.innerWidth + $9cc7f751f8d72599$var$PARALLAX_PER_SLIDE * Math.max(slideCount - 1, 1);
        height = window.innerHeight;
        canvas.width = width * dpr;
        canvas.height = height * dpr;
        canvas.style.width = `${width}px`;
        canvas.style.height = `${height}px`;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        const now = performance.now();
        layout(now);
        draw(now);
    }
    // Current CSS parallax offset of the canvas (animated), in px
    function parallaxOffset() {
        const t = getComputedStyle(canvas).transform;
        return t && t !== "none" ? new DOMMatrixReadOnly(t).m41 : 0;
    }
    window.addEventListener("pointermove", (e)=>{
        if (e.pointerType === "touch") return;
        pointer.x = e.clientX - parallaxOffset();
        pointer.y = e.clientY;
        pointer.active = true;
    });
    const leave = ()=>pointer.active = false;
    document.addEventListener("pointerleave", leave);
    window.addEventListener("blur", leave);
    document.addEventListener("slidechange", (e)=>{
        const countChanged = e.detail.count !== slideCount;
        slideCount = e.detail.count;
        canvas.style.setProperty("--parallax", `${-e.detail.index * $9cc7f751f8d72599$var$PARALLAX_PER_SLIDE}px`);
        if (countChanged) resize();
    });
    document.addEventListener("visibilitychange", ()=>{
        if (document.hidden) running = false;
        else start();
    });
    window.addEventListener("resize", resize);
    // Redraw once the monospace font arrives, so widths and glyphs are right
    document.fonts?.ready.then(()=>draw(performance.now()));
    resize();
    start();
}


// Typewriter effects.
// - .typer[data-words="a|b|c"]: types each word, holds it, deletes it, moves on.
// - .typed-block: types its text once, the first time its slide becomes active.
const $fd85e92986dcf0e0$var$TYPE_MS = 55;
const $fd85e92986dcf0e0$var$DELETE_MS = 28;
const $fd85e92986dcf0e0$var$HOLD_MS = 1600;
const $fd85e92986dcf0e0$var$BLOCK_MS = 16;
function $fd85e92986dcf0e0$export$2e2bcd8739ae039() {
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    document.querySelectorAll(".typer[data-words]").forEach((el)=>{
        const words = el.dataset.words.split("|");
        if (reduceMotion) {
            el.textContent = words[0];
            return;
        }
        let w = 0;
        let i = 0;
        let deleting = false;
        const tick = ()=>{
            const word = words[w];
            i += deleting ? -1 : 1;
            el.textContent = word.slice(0, i);
            let delay = deleting ? $fd85e92986dcf0e0$var$DELETE_MS : $fd85e92986dcf0e0$var$TYPE_MS;
            if (!deleting && i === word.length) {
                deleting = true;
                delay = $fd85e92986dcf0e0$var$HOLD_MS;
            } else if (deleting && i === 0) {
                deleting = false;
                w = (w + 1) % words.length;
                delay = 300;
            }
            setTimeout(tick, delay);
        };
        tick();
    });
    document.querySelectorAll(".typed-block").forEach((el)=>{
        const text = el.textContent.trim();
        el.parentElement.setAttribute("aria-label", text);
        if (reduceMotion) return;
        el.textContent = "";
        const slide = el.closest(".slide");
        let started = false;
        const start = ()=>{
            if (started) return;
            started = true;
            let i = 0;
            const tick = ()=>{
                i += 1;
                el.textContent = text.slice(0, i);
                if (i < text.length) setTimeout(tick, $fd85e92986dcf0e0$var$BLOCK_MS);
            };
            setTimeout(tick, 500);
        };
        if (slide.classList.contains("is-active")) start();
        document.addEventListener("slidechange", ()=>{
            if (slide.classList.contains("is-active")) start();
        });
    });
}


// Tech chips gliding along an arc, like a carousel.
// - Chips move steadily right to left and wrap around off-screen.
// - The chip in the middle grows and turns dark (spotlight); chips fade out at the edges.
// - Hovering the arc slows it down; it only runs while the About slide is on screen.
const $3163d2cda9065975$var$SPEED = 38; // px per second along the arc
const $3163d2cda9065975$var$HOVER_SPEED = 8;
const $3163d2cda9065975$var$GAP_PER_CHIP = 1.28; // distance between chip centres, in chip widths
function $3163d2cda9065975$export$2e2bcd8739ae039() {
    const arc = document.querySelector(".arc");
    if (!arc) return;
    const slide = arc.closest(".slide");
    const chips = [
        ...arc.querySelectorAll(".arc__ring li")
    ];
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let width = 0;
    let radius = 1500;
    let gap = 92;
    let offset = 0;
    let speed = $3163d2cda9065975$var$SPEED;
    let target = $3163d2cda9065975$var$SPEED;
    let last = 0;
    let raf = 0;
    let running = false;
    let focus = -1;
    function measure() {
        width = arc.clientWidth;
        const chip = chips[0].offsetWidth || 72;
        radius = Math.max(width * 1.25, 520);
        // the loop must be wider than the arc, so chips wrap where nobody sees them
        gap = Math.max(chip * $3163d2cda9065975$var$GAP_PER_CHIP, (width + chip * 2) / chips.length);
        place();
    }
    function place() {
        const loop = gap * chips.length;
        let nearest = -1;
        let nearestDist = Infinity;
        chips.forEach((chip, i)=>{
            // position along the arc, centred on 0
            let s = ((i * gap - offset) % loop + loop) % loop;
            s -= loop / 2;
            const theta = s / radius;
            const x = Math.sin(theta) * radius;
            const y = (1 - Math.cos(theta)) * radius;
            const t = x / (width / 2); // -1 … 1 across the arc
            const scale = 1 + 0.32 * Math.exp(-((t * 2.4) ** 2));
            const fade = Math.min(1, Math.max(0, (1 - Math.abs(t)) * 4));
            chip.style.transform = `translate(${x}px, ${y}px) scale(${scale})`;
            chip.style.opacity = fade;
            if (Math.abs(x) < nearestDist) {
                nearestDist = Math.abs(x);
                nearest = i;
            }
        });
        if (nearest !== focus) {
            chips[focus]?.classList.remove("is-focus");
            chips[nearest].classList.add("is-focus");
            focus = nearest;
        }
    }
    function tick(time) {
        raf = requestAnimationFrame(tick);
        const dt = last ? Math.min((time - last) / 1000, 0.1) : 0;
        last = time;
        speed += (target - speed) * Math.min(1, dt * 4);
        offset += speed * dt;
        place();
    }
    function setRunning(on) {
        if (on === running || reduceMotion) return;
        running = on;
        if (on) {
            last = 0;
            raf = requestAnimationFrame(tick);
        } else cancelAnimationFrame(raf);
    }
    arc.addEventListener("pointerenter", ()=>target = $3163d2cda9065975$var$HOVER_SPEED);
    arc.addEventListener("pointerleave", ()=>target = $3163d2cda9065975$var$SPEED);
    const sync = ()=>setRunning(slide.classList.contains("is-active") && !document.hidden);
    document.addEventListener("slidechange", sync);
    document.addEventListener("visibilitychange", sync);
    window.addEventListener("resize", measure);
    measure();
}


// Projects shown as "stories": one card at a time, with progress bars on top.
// - Auto-advances every STORY_MS while the projects slide is on screen.
// - Tap the left third of the card to go back, the rest to go forward,
//   swipe sideways to change project, press and hold to pause.
// - Going forward from the last project (or back from the first) moves on to
//   the next (or previous) slide; auto-advance just loops through the projects.
// - Each card shows an animated SVG diagram of the project; only the visible
//   card's animation runs, and it restarts when the card is shown again.
const $669b05cb7b0fa76a$var$STORY_MS = 9000;
const $669b05cb7b0fa76a$var$HOLD_MS = 220;
const $669b05cb7b0fa76a$var$SWIPE_PX = 40;
const $669b05cb7b0fa76a$var$MOVE_TOLERANCE = 10;
function $669b05cb7b0fa76a$export$2e2bcd8739ae039() {
    const root = document.getElementById("stories");
    if (!root) return;
    const slide = root.closest(".slide");
    const frame = root.querySelector(".stories__frame");
    const stories = [
        ...root.querySelectorAll(".story")
    ];
    // The animated diagram of each card (SMIL animations)
    const diagrams = stories.map((s)=>s.querySelector("svg"));
    diagrams.forEach((svg)=>svg?.pauseAnimations());
    const bars = [
        ...root.querySelectorAll(".stories__bar i")
    ];
    const pickers = [
        ...document.querySelectorAll("[data-story]")
    ];
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let index = 0;
    let elapsed = 0;
    let last = 0;
    let raf = 0;
    let visible = false;
    let paused = false;
    let leftFromEnd = false;
    const seen = new Set();
    function show(i) {
        const prev = index;
        index = (i + stories.length) % stories.length;
        elapsed = 0;
        seen.add(index);
        stories.forEach((story, k)=>{
            const active = k === index;
            story.classList.toggle("is-active", active);
            story.classList.toggle("is-before", k < index);
            story.classList.toggle("is-after", k > index);
            story.setAttribute("aria-hidden", String(!active));
            story.inert = !active;
        });
        if (prev !== index) diagrams[prev]?.pauseAnimations();
        diagrams[index]?.setCurrentTime(0);
        playCurrent();
        pickers.forEach((p, k)=>{
            p.classList.toggle("is-active", k === index);
            p.classList.toggle("is-seen", seen.has(k) && k !== index);
            p.setAttribute("aria-current", String(k === index));
        });
        paint();
    }
    // A move made by the visitor (tap, swipe, arrows, keys)
    function step(dir) {
        const target = index + dir;
        if (target < 0 || target >= stories.length) {
            leftFromEnd = target >= stories.length;
            document.getElementById(dir > 0 ? "next" : "prev").click();
            return;
        }
        show(target);
    }
    function playCurrent() {
        if (visible && !paused) diagrams[index]?.unpauseAnimations();
    }
    function paint() {
        const done = reduceMotion ? 1 : Math.min(elapsed / $669b05cb7b0fa76a$var$STORY_MS, 1);
        bars.forEach((bar, k)=>{
            bar.style.transform = `scaleX(${k < index ? 1 : k > index ? 0 : done})`;
        });
        pickers.forEach((p, k)=>p.style.setProperty("--p", k === index ? done : 0));
    }
    function tick(time) {
        raf = requestAnimationFrame(tick);
        const dt = last ? time - last : 0;
        last = time;
        if (!paused && !reduceMotion) {
            elapsed += dt;
            if (elapsed >= $669b05cb7b0fa76a$var$STORY_MS) show(index + 1);
        }
        paint();
    }
    function setVisible(on) {
        if (on === visible) return;
        visible = on;
        if (on) {
            last = 0;
            raf = requestAnimationFrame(tick);
            // came back after finishing the stories: start them over
            if (leftFromEnd) {
                leftFromEnd = false;
                show(0);
            }
            playCurrent();
        } else {
            cancelAnimationFrame(raf);
            diagrams[index]?.pauseAnimations();
        }
    }
    function setPaused(on) {
        paused = on;
        root.classList.toggle("is-paused", on);
        if (on) diagrams[index]?.pauseAnimations();
        else playCurrent();
    }
    const sync = ()=>setVisible(slide.classList.contains("is-active") && !document.hidden);
    document.addEventListener("slidechange", sync);
    document.addEventListener("visibilitychange", sync);
    // Tap / hold / swipe on the card
    let down = null;
    let holdTimer;
    frame.addEventListener("pointerdown", (e)=>{
        if (e.button !== 0 || e.target.closest("a, button")) return;
        down = {
            x: e.clientX,
            y: e.clientY,
            held: false
        };
        holdTimer = setTimeout(()=>{
            down.held = true;
            setPaused(true);
        }, $669b05cb7b0fa76a$var$HOLD_MS);
    });
    frame.addEventListener("pointermove", (e)=>{
        if (down && Math.hypot(e.clientX - down.x, e.clientY - down.y) > $669b05cb7b0fa76a$var$MOVE_TOLERANCE) clearTimeout(holdTimer);
    });
    frame.addEventListener("pointerup", (e)=>{
        clearTimeout(holdTimer);
        if (!down) return;
        const { x: x, y: y, held: held } = down;
        down = null;
        if (held) {
            setPaused(false);
            return;
        }
        const dx = e.clientX - x;
        const dy = e.clientY - y;
        if (Math.abs(dx) > $669b05cb7b0fa76a$var$SWIPE_PX && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1);
        else if (Math.hypot(dx, dy) <= $669b05cb7b0fa76a$var$MOVE_TOLERANCE) {
            const r = frame.getBoundingClientRect();
            step(e.clientX - r.left < r.width / 3 ? -1 : 1);
        }
    });
    const cancel = ()=>{
        clearTimeout(holdTimer);
        if (down?.held) setPaused(false);
        down = null;
    };
    frame.addEventListener("pointercancel", cancel);
    frame.addEventListener("pointerleave", cancel);
    frame.addEventListener("contextmenu", (e)=>e.preventDefault());
    // Keep swipes on the card from also changing the page's slide
    [
        "touchstart",
        "touchend"
    ].forEach((type)=>frame.addEventListener(type, (e)=>e.stopPropagation(), {
            passive: true
        }));
    root.querySelectorAll("[data-step]").forEach((btn)=>btn.addEventListener("click", ()=>step(Number(btn.dataset.step))));
    pickers.forEach((p)=>p.addEventListener("click", ()=>show(Number(p.dataset.story))));
    // While the carousel has focus, arrows move between projects instead of slides
    root.addEventListener("keydown", (e)=>{
        if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
            e.stopPropagation();
            step(e.key === "ArrowRight" ? 1 : -1);
        } else if (e.key === " " && e.target === root) {
            e.preventDefault();
            setPaused(!paused);
        }
    });
    show(0);
}


// Blog slide: latest posts from the blog API, with tag filter, search and
// "Older posts". Loads the first time the slide is opened.

var $jjQ3N = parcelRequire("jjQ3N");
const $f319379f179a7290$var$PAGE_SIZE = 5;
const $f319379f179a7290$var$SEARCH_DELAY_MS = 300;
function $f319379f179a7290$export$2e2bcd8739ae039() {
    const list = document.getElementById("blog-list");
    if (!list) return;
    const slide = list.closest(".slide");
    const tagBar = document.getElementById("blog-tags");
    const search = document.getElementById("blog-search");
    const status = document.getElementById("blog-status");
    const more = document.getElementById("blog-more");
    let started = false;
    let page = 1;
    let tag = "";
    let query = "";
    let request = 0; // ignore answers to outdated requests
    let searchTimer;
    function setStatus(text, { retry: retry = false } = {}) {
        status.textContent = text;
        status.hidden = !text;
        if (retry) {
            const btn = document.createElement("button");
            btn.type = "button";
            btn.className = "blog__retry";
            btn.textContent = "Try again";
            btn.addEventListener("click", ()=>{
                load();
                loadTags();
            });
            status.append(" ", btn);
        }
    }
    function card(p) {
        const tags = p.tags.map((t)=>`<span>#${(0, $jjQ3N.esc)(t)}</span>`).join("");
        return `<li>
      <a class="post-card" href="${(0, $jjQ3N.postUrl)(p.slug)}">
        <span class="post-card__meta">${(0, $jjQ3N.esc)((0, $jjQ3N.formatDate)(p.published_at))} \xb7 ${p.reading_minutes} min read</span>
        <span class="post-card__main">
          <span class="post-card__title">${(0, $jjQ3N.esc)(p.title)}</span>
          ${p.summary ? `<span class="post-card__summary">${(0, $jjQ3N.esc)(p.summary)}</span>` : ""}
          ${tags ? `<span class="post-card__tags">${tags}</span>` : ""}
          <span class="post-card__more">Read more <i class="fa fa-arrow-right" aria-hidden="true"></i></span>
        </span>
      </a>
    </li>`;
    }
    async function load({ append: append = false } = {}) {
        const id = ++request;
        const params = new URLSearchParams({
            page: page,
            limit: $f319379f179a7290$var$PAGE_SIZE
        });
        if (tag) params.set("tag", tag);
        if (query) params.set("q", query);
        if (!append) setStatus("Loading posts\u2026");
        more.disabled = true;
        try {
            const data = await (0, $jjQ3N.api)(`/api/posts?${params}`);
            if (id !== request) return;
            const html = data.posts.map(card).join("");
            if (append) list.insertAdjacentHTML("beforeend", html);
            else list.innerHTML = html;
            more.hidden = data.page >= data.total_pages;
            if (data.total === 0) setStatus(tag || query ? "No posts match that yet." : "First posts are on their way.");
            else setStatus("");
        } catch  {
            if (id !== request) return;
            if (!append) list.innerHTML = "";
            more.hidden = true;
            setStatus("Couldn't load the posts.", {
                retry: true
            });
        } finally{
            more.disabled = false;
        }
    }
    async function loadTags() {
        try {
            const { tags: tags } = await (0, $jjQ3N.api)("/api/tags");
            if (!tags.length) return;
            tagBar.innerHTML = [
                `<button type="button" class="chip is-active" data-tag="">All</button>`
            ].concat(tags.slice(0, 12).map((t)=>`<button type="button" class="chip" data-tag="${(0, $jjQ3N.esc)(t.name)}">#${(0, $jjQ3N.esc)(t.name)}</button>`)).join("");
            tagBar.hidden = false;
        } catch  {
        /* the list shows the error */ }
    }
    tagBar.addEventListener("click", (e)=>{
        const btn = e.target.closest("[data-tag]");
        if (!btn) return;
        tag = btn.dataset.tag;
        tagBar.querySelectorAll(".chip").forEach((c)=>c.classList.toggle("is-active", c === btn));
        page = 1;
        load();
    });
    search.addEventListener("input", ()=>{
        clearTimeout(searchTimer);
        searchTimer = setTimeout(()=>{
            query = search.value.trim();
            page = 1;
            load();
        }, $f319379f179a7290$var$SEARCH_DELAY_MS);
    });
    // Arrow keys move the caret in the search box, not the slides
    search.addEventListener("keydown", (e)=>e.stopPropagation());
    more.addEventListener("click", ()=>{
        page += 1;
        load({
            append: true
        });
    });
    function start() {
        if (started || !slide.classList.contains("is-active")) return;
        started = true;
        load();
        loadTags();
    }
    document.addEventListener("slidechange", start);
}


// Navigation hint shown in the bottom bar, instead of a page number.
// - Adapts to how the visitor moves: a swipe animation on touch screens,
//   a scroll wheel with a mouse or trackpad, arrow keys once they use the keyboard.
// - Always names the next section ("Scroll for About"); the deck loops, so after
//   the last one comes Home again. Clicking it goes there.
// - Once the visitor has moved around a couple of times it shrinks to "About →",
//   and stays small on later visits.
// - Before the first move, the deck "peeks" at the next slide now and then.
// Also builds the section dots. Runs before the slider so they get its
// [data-goto] click handling and the first "slidechange".
const $e25761da9e9fcb4b$var$LEARNED_KEY = "hint-learned";
const $e25761da9e9fcb4b$var$LEARN_AFTER = 2; // moves before the hint shrinks
const $e25761da9e9fcb4b$var$PEEK_AFTER_MS = 5000;
const $e25761da9e9fcb4b$var$PEEK_EVERY_MS = 9000;
const $e25761da9e9fcb4b$var$MAX_PEEKS = 2;
const $e25761da9e9fcb4b$var$ACTIONS = {
    touch: "Swipe",
    wheel: "Scroll",
    keys: "Press \u2192"
};
function $e25761da9e9fcb4b$export$2e2bcd8739ae039() {
    const hint = document.getElementById("hint");
    const dotsNav = document.getElementById("dots");
    const track = document.getElementById("track");
    if (!hint || !track) return;
    const slides = [
        ...track.querySelectorAll(".slide")
    ];
    const action = hint.querySelector(".hint__action");
    const next = hint.querySelector(".hint__next");
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let index = 0;
    let moves = -1; // the slider's first "slidechange" is the initial position, not a move
    let peeks = 0;
    let peekTimer;
    let mode = window.matchMedia("(pointer: coarse)").matches ? "touch" : "wheel";
    const learned = ()=>{
        try {
            return localStorage.getItem($e25761da9e9fcb4b$var$LEARNED_KEY) === "1";
        } catch  {
            return false;
        }
    };
    if (learned()) hint.classList.add("is-compact");
    // Section dots (no numbers); the active one stretches into a pill
    slides.forEach((slide)=>{
        const dot = document.createElement("a");
        dot.href = `#${slide.id}`;
        dot.className = "dots__dot";
        dot.dataset.goto = "";
        dot.setAttribute("aria-label", slide.getAttribute("aria-label"));
        dot.dataset.label = slide.getAttribute("aria-label");
        dotsNav.append(dot);
    });
    const dots = [
        ...dotsNav.children
    ];
    function render() {
        hint.dataset.mode = mode;
        action.textContent = $e25761da9e9fcb4b$var$ACTIONS[mode];
        next.textContent = slides[(index + 1) % slides.length].getAttribute("aria-label");
        hint.setAttribute("aria-label", `Next section: ${next.textContent}`);
        dots.forEach((d, i)=>{
            d.classList.toggle("is-active", i === index);
            d.setAttribute("aria-current", i === index ? "true" : "false");
        });
    }
    function setMode(m) {
        if (m === mode) return;
        mode = m;
        render();
    }
    window.addEventListener("touchstart", ()=>setMode("touch"), {
        passive: true
    });
    window.addEventListener("wheel", ()=>setMode("wheel"), {
        passive: true
    });
    window.addEventListener("keydown", (e)=>{
        if ([
            "ArrowRight",
            "ArrowLeft",
            "PageDown",
            "PageUp"
        ].includes(e.key)) setMode("keys");
    });
    hint.addEventListener("click", ()=>{
        document.getElementById("next").click();
    });
    // Peek at the next slide while the visitor hasn't moved yet
    function schedulePeek(delay) {
        clearTimeout(peekTimer);
        if (reduceMotion || moves > 0 || peeks >= $e25761da9e9fcb4b$var$MAX_PEEKS || index !== 0) return;
        peekTimer = setTimeout(()=>{
            peeks += 1;
            track.classList.add("is-peeking");
            hint.classList.add("is-nudging");
            setTimeout(()=>{
                track.classList.remove("is-peeking");
                hint.classList.remove("is-nudging");
            }, 1400);
            schedulePeek($e25761da9e9fcb4b$var$PEEK_EVERY_MS);
        }, delay);
    }
    document.addEventListener("slidechange", (e)=>{
        index = e.detail.index;
        moves += 1;
        if (moves >= $e25761da9e9fcb4b$var$LEARN_AFTER && !hint.classList.contains("is-compact")) {
            hint.classList.add("is-compact");
            try {
                localStorage.setItem($e25761da9e9fcb4b$var$LEARNED_KEY, "1");
            } catch  {
            /* private mode: shrink for this visit only */ }
        }
        render();
        if (moves > 0) clearTimeout(peekTimer);
        else schedulePeek($e25761da9e9fcb4b$var$PEEK_AFTER_MS);
    });
    render();
}


// Horizontal full-screen slide navigation: nav links, arrows, keyboard,
// mouse wheel / trackpad and touch swipe all move between sections.
// The deck loops: past the last slide comes the first one again (and back),
// with a quick fade instead of sliding back across every slide.
const $a102f01a5223898a$var$TRANSITION_MS = 800;
const $a102f01a5223898a$var$WRAP_FADE_MS = 280;
const $a102f01a5223898a$var$WHEEL_THRESHOLD = 40;
const $a102f01a5223898a$var$SWIPE_THRESHOLD = 50;
function $a102f01a5223898a$export$2e2bcd8739ae039() {
    const track = document.getElementById("track");
    const slides = [
        ...track.querySelectorAll(".slide")
    ];
    const navLinks = document.querySelectorAll(".site-nav__link");
    const prevBtn = document.getElementById("prev");
    const nextBtn = document.getElementById("next");
    let index = 0;
    let locked = false;
    let wheelDelta = 0;
    let wheelTimer;
    function goTo(target, { updateHash: updateHash = true } = {}) {
        const next = (target % slides.length + slides.length) % slides.length;
        if (next === index && track.dataset.ready) return;
        const wrapped = track.dataset.ready && Math.abs(next - index) === slides.length - 1 && (target < 0 || target >= slides.length);
        index = next;
        track.dataset.ready = "1";
        const position = `translate3d(${-index * 100}vw, 0, 0)`;
        if (wrapped) {
            track.classList.add("is-wrapping");
            setTimeout(()=>{
                track.classList.add("no-transition");
                track.style.transform = position;
                track.offsetWidth; // apply the jump before fading back in
                track.classList.remove("no-transition", "is-wrapping");
            }, $a102f01a5223898a$var$WRAP_FADE_MS);
        } else track.style.transform = position;
        slides.forEach((slide, i)=>{
            const active = i === index;
            slide.classList.toggle("is-active", active);
            slide.setAttribute("aria-hidden", String(!active));
            slide.inert = !active;
        });
        navLinks.forEach((link)=>link.classList.toggle("is-active", indexOfHash(link.hash) === index));
        document.body.dataset.slide = slides[index].id;
        document.dispatchEvent(new CustomEvent("slidechange", {
            detail: {
                index: index,
                count: slides.length
            }
        }));
        if (updateHash) history.replaceState(null, "", `#${slides[index].id}`);
        locked = true;
        setTimeout(()=>locked = false, $a102f01a5223898a$var$TRANSITION_MS);
    }
    function indexOfHash(hash) {
        return slides.findIndex((s)=>`#${s.id}` === hash);
    }
    // A slide whose content is taller than the screen scrolls vertically first;
    // only once it reaches its edge does the wheel move to the next slide.
    function canScrollInside(deltaY) {
        const el = slides[index];
        if (el.scrollHeight <= el.clientHeight + 1) return false;
        if (deltaY > 0) return el.scrollTop + el.clientHeight < el.scrollHeight - 1;
        return el.scrollTop > 0;
    }
    document.querySelectorAll("[data-goto]").forEach((el)=>el.addEventListener("click", (e)=>{
            e.preventDefault();
            const target = indexOfHash(el.hash);
            if (target !== -1) goTo(target);
        }));
    prevBtn.addEventListener("click", ()=>goTo(index - 1));
    nextBtn.addEventListener("click", ()=>goTo(index + 1));
    window.addEventListener("keydown", (e)=>{
        if (e.target.closest("input, textarea")) return;
        if ([
            "ArrowRight",
            "PageDown"
        ].includes(e.key)) goTo(index + 1);
        else if ([
            "ArrowLeft",
            "PageUp"
        ].includes(e.key)) goTo(index - 1);
        else if (e.key === "Home") goTo(0);
        else if (e.key === "End") goTo(slides.length - 1);
    });
    window.addEventListener("wheel", (e)=>{
        const delta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
        if (Math.abs(e.deltaY) >= Math.abs(e.deltaX) && canScrollInside(e.deltaY)) return;
        e.preventDefault();
        if (locked) return;
        wheelDelta += delta;
        clearTimeout(wheelTimer);
        wheelTimer = setTimeout(()=>wheelDelta = 0, 150);
        if (Math.abs(wheelDelta) >= $a102f01a5223898a$var$WHEEL_THRESHOLD) {
            goTo(index + Math.sign(wheelDelta));
            wheelDelta = 0;
        }
    }, {
        passive: false
    });
    let touchX = 0;
    let touchY = 0;
    window.addEventListener("touchstart", (e)=>{
        touchX = e.touches[0].clientX;
        touchY = e.touches[0].clientY;
    }, {
        passive: true
    });
    window.addEventListener("touchend", (e)=>{
        const dx = e.changedTouches[0].clientX - touchX;
        const dy = e.changedTouches[0].clientY - touchY;
        if (Math.abs(dx) > $a102f01a5223898a$var$SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy) * 1.2) goTo(index + (dx < 0 ? 1 : -1));
    }, {
        passive: true
    });
    // The browser scrolls the (overflow: hidden) deck to bring a #hash target into
    // view; positioning is done with transforms only, so undo that scroll.
    const deck = track.parentElement;
    deck.addEventListener("scroll", ()=>{
        deck.scrollLeft = 0;
        deck.scrollTop = 0;
    });
    // Support back/forward and manually typed #hash links.
    window.addEventListener("hashchange", ()=>{
        const i = indexOfHash(location.hash);
        if (i !== -1) goTo(i, {
            updateHash: false
        });
    });
    const initial = indexOfHash(location.hash);
    track.classList.add("no-transition");
    goTo(initial === -1 ? 0 : initial, {
        updateHash: false
    });
    requestAnimationFrame(()=>requestAnimationFrame(()=>track.classList.remove("no-transition")));
}



var $wUWAt = parcelRequire("wUWAt");
// Contact slide: the copy button next to the email address
function $9db6fb3c03031dce$export$2e2bcd8739ae039() {
    for (const button of document.querySelectorAll("[data-copy]")){
        const icon = button.querySelector("i");
        const note = button.querySelector(".contact__copied");
        let timer = 0;
        button.addEventListener("click", async ()=>{
            try {
                await navigator.clipboard.writeText(button.dataset.copy);
            } catch  {
                // no clipboard access (old browser, http): open the mail app instead
                location.href = `mailto:${button.dataset.copy}`;
                return;
            }
            icon.className = "fa fa-check";
            note.textContent = "Copied";
            clearTimeout(timer);
            timer = setTimeout(()=>{
                icon.className = "fa fa-clone";
                note.textContent = "";
            }, 1800);
        });
    }
}


// Pages inside the portfolio: links to cv.html (data-cv) and to the case
// studies (data-sheet) open that page's <main> in a full-screen panel instead
// of loading another page. The panel shows the page's own content, so each
// page is written once and stays the URL to share. Back closes the panel,
// like leaving a page; /#cv, /#marketplace... open it directly.

var $lIWMB = parcelRequire("lIWMB");

var $ijXQL = parcelRequire("ijXQL");
function $d30c4cec921d0307$export$2e2bcd8739ae039() {
    // data-cv="fit" (or data-sheet="section") opens the page at that section
    const links = [
        ...document.querySelectorAll("a[data-cv], a[data-sheet]")
    ];
    if (!links.length || typeof HTMLDialogElement === "undefined") return;
    // page file -> its name in the URL hash: cv.html -> #cv
    const pageOf = (link)=>link.getAttribute("href").split("#")[0].replace(/^\//, "");
    const hashOf = (page)=>page.replace(/\.html$/, "");
    const pages = new Set(links.map(pageOf));
    const sheet = document.createElement("dialog");
    sheet.className = "cv-sheet";
    sheet.innerHTML = `
    <div class="cv-sheet__bar">
      <a class="cv-sheet__page" href="#" target="_blank" rel="noopener">
        <i class="fa fa-external-link" aria-hidden="true"></i> Open as a page
      </a>
      <button type="button" class="cv-sheet__close" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
    </div>
    <div class="cv-sheet__body"></div>`;
    document.body.appendChild(sheet);
    const body = sheet.querySelector(".cv-sheet__body");
    const pageLink = sheet.querySelector(".cv-sheet__page");
    // The slide deck listens on window for wheel, swipes and arrow keys: keep
    // them inside the panel so it scrolls and the slides stay put
    for (const type of [
        "wheel",
        "touchstart",
        "touchmove",
        "touchend",
        "keydown"
    ])sheet.addEventListener(type, (e)=>e.stopPropagation(), {
        passive: true
    });
    const cache = new Map(); // page -> Promise of its <main>
    function load(page) {
        if (!cache.has(page)) cache.set(page, fetch(page).then((res)=>{
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            return res.text();
        }).then((html)=>{
            const doc = new DOMParser().parseFromString(html, "text/html");
            const main = doc.querySelector("main");
            if (!main) throw new Error(`no <main> in ${page}`);
            main.querySelector("[data-print]")?.remove(); // would print the home page here
            return {
                main: document.adoptNode(main),
                title: doc.title
            };
        }).catch((err)=>{
            cache.delete(page); // try again next time
            throw err;
        }));
        return cache.get(page);
    }
    let pushed = false;
    let current = "";
    async function open(page, target) {
        let loaded;
        try {
            loaded = await load(page);
        } catch  {
            location.href = page + (target ? `#${target}` : ""); // can't load it here: go to the page
            return;
        }
        if (current !== page) {
            body.replaceChildren(loaded.main);
            (0, $lIWMB.default)(body);
            (0, $ijXQL.default)(body);
            current = page;
        }
        sheet.setAttribute("aria-label", loaded.title.split(" | ")[0]);
        pageLink.href = page;
        if (!sheet.open) {
            sheet.showModal();
            history.pushState({
                sheet: page
            }, "", `#${hashOf(page)}`);
            pushed = true;
        } else history.replaceState({
            sheet: page
        }, "", `#${hashOf(page)}`);
        const to = target ? body.querySelector(`#${CSS.escape(target)}`) : null;
        if (to) to.scrollIntoView({
            block: "start"
        });
        else body.scrollTop = 0;
        (to?.querySelector("textarea") || sheet.querySelector(".cv-sheet__close")).focus({
            preventScroll: true
        });
    }
    function close() {
        if (sheet.open) sheet.close();
    }
    for (const link of links){
        link.addEventListener("click", (e)=>{
            if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return; // new tab: the real page
            e.preventDefault();
            open(pageOf(link), link.dataset.cv || link.dataset.sheet || "");
        });
        link.addEventListener("pointerenter", ()=>load(pageOf(link)).catch(()=>{}), {
            once: true
        }); // fetch while they aim
    }
    // Jump links inside a page (#mp-features...) scroll the panel: a hash
    // change would close it, or move the slides behind it
    body.addEventListener("click", (e)=>{
        const a = e.target.closest('a[href^="#"]');
        if (!a) return;
        const to = body.querySelector(`#${CSS.escape(a.getAttribute("href").slice(1))}`);
        if (to) {
            e.preventDefault();
            to.scrollIntoView({
                block: "start",
                behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth"
            });
        }
    });
    sheet.querySelector(".cv-sheet__close").addEventListener("click", close);
    sheet.addEventListener("keydown", (e)=>{
        if (e.key === "Escape") {
            e.preventDefault();
            close();
        }
    });
    // Escape, the close button and Back all end here: leave the panel's history entry
    sheet.addEventListener("close", ()=>{
        if (pushed) {
            pushed = false;
            if (history.state?.sheet) history.back();
        }
    });
    window.addEventListener("popstate", ()=>{
        if (sheet.open && !history.state?.sheet) {
            pushed = false;
            sheet.close();
        }
    });
    // A shared link to /#cv or /#marketplace opens that page
    const shared = [
        ...pages
    ].find((p)=>`#${hashOf(p)}` === location.hash);
    if (shared) {
        history.replaceState(null, "", location.pathname + location.search);
        open(shared, "");
    }
}


(0, $kVpyw.default)();
(0, $9cc7f751f8d72599$export$2e2bcd8739ae039)();
(0, $fd85e92986dcf0e0$export$2e2bcd8739ae039)();
// Before the slider, so they hear the first "slidechange"
(0, $3163d2cda9065975$export$2e2bcd8739ae039)();
(0, $669b05cb7b0fa76a$export$2e2bcd8739ae039)();
(0, $f319379f179a7290$export$2e2bcd8739ae039)();
(0, $e25761da9e9fcb4b$export$2e2bcd8739ae039)();
(0, $a102f01a5223898a$export$2e2bcd8739ae039)();
(0, $wUWAt.default)();
(0, $9db6fb3c03031dce$export$2e2bcd8739ae039)();
(0, $d30c4cec921d0307$export$2e2bcd8739ae039)();


//# sourceMappingURL=MyPortfolio.d030626f.js.map
